<xng-breadcrumb [separator]="separatorTemplate">
    <ng-container *xngBreadcrumbItem="let breadcrumb">
        <ng-container>{{ breadcrumb | translate }}</ng-container>
      </ng-container>
</xng-breadcrumb>

<ng-template #separatorTemplate>
    <span class="breadcrumb-arrow-icon"></span>
</ng-template>